import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'datagridFilter',
  pure: false
})
export class DatagridFilterPipe implements PipeTransform {
  transform(items: Array<any>, filters: Array<any>) {
    return items.filter(item => {
      let valid = true;

      filters.forEach(filter => {
        if ((item[filter.field] !== undefined) && (item[filter.field] !== filter.value)) {
          valid = false;
        }
      });

      return valid;
    });
  }
}


// WEBPACK FOOTER //
// ./libs/atenea-cms/src/datagrid/shared/datagrid-filter.pipe.ts